// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './certidao-diretiva.scss';

// Utils
import { PRODUCT_KEY_COUNTRY } from '../../../common/constants';

// Redux
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';
import { getDocumentTypeList } from '../../../common/lists/document-type';

class CertidaoDiretivaComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            validDocumentType: true,
            documentType: null
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        if(this.validateForm()) {
            let metadata = [
                { key: PRODUCT_KEY_COUNTRY, value: this.state.documentType.code }
            ];

            // Add product to basket
            let product = this.props.product;
            product.metadata = metadata;
            product.title = this.props.t("products.products." + product.title) + " - " + this.state.documentType.code;

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
                
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);
            this.props.onClose();
        }
    }

    validateForm() {
        this.setState({
            validDocumentType: this.state.documentType !== null
        });

        let validationResult = (this.state.documentType !== null);

        return validationResult;
    }

    render() {
        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12" style={{textAlign: "justify"}}>
                    <ul style={{marginLeft: "20px", padding: 0}}>
                        <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.qualification-doc")}</li>
                        <li>{this.props.t("products.labels.digital-document")}</li>
                    </ul>
                </div>
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="cedula">{this.props.t("products.labels.country")}</label>
                        <Dropdown id="documentType" value={this.state.documentType} options={getDocumentTypeList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("documentType", evt.value)}></Dropdown>
                        { this.state.validDocumentType ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    </div>
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() } />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(CertidaoDiretivaComponent));